import React from 'react';
import './UnderHeader.scss';
import Timer from './Timer/Timer';
import Scoreboard from './Scoreboard/Scoreboard';
//import '../../../styles/svg_icons/logo_main.svg';


const UnderHeader = (props) => {
 const {dispatch} =props;

    
        return (
            <div className="UnderHeader">
                <Scoreboard 
                authData={props.authData}
                dispatch={dispatch}/>
               {/* <Timer />*/}
                
            </div>
        )
    
}
export default UnderHeader;